"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractAllowanceButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const approve_json_1 = __importDefault(require("@framework/abis/json/ERC20Simple/approve.json"));
const setApprovalForAll_json_1 = __importDefault(require("@framework/abis/json/ERC721Simple/setApprovalForAll.json"));
const setApprovalForAll_json_2 = __importDefault(require("@framework/abis/json/ERC1155Simple/setApprovalForAll.json"));
const utils_1 = require("../../../../utils");
const dialogs_1 = require("../../../../dialogs");
const dialog_1 = require("./dialog");
const ContractAllowanceButton = (props) => {
    const { className, contract, contract: { address, contractFeatures, contractType, decimals }, disabled, variant, } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)(async (values) => {
        if (contractType === types_1.TokenType.ERC20) {
            return writeContractAsync({
                address: address,
                abi: approve_json_1.default,
                functionName: "approve",
                args: [values.address, values.amount],
            });
        }
        else if (contractType === types_1.TokenType.ERC721 || contractType === types_1.TokenType.ERC998) {
            return writeContractAsync({
                address: address,
                abi: setApprovalForAll_json_1.default,
                functionName: "setApprovalForAll",
                args: [values.address, true],
            });
        }
        else if (contractType === types_1.TokenType.ERC1155) {
            return writeContractAsync({
                address: address,
                abi: setApprovalForAll_json_2.default,
                functionName: "setApprovalForAll",
                args: [values.address, true],
            });
        }
        else {
            throw new Error("unsupported token type");
        }
    });
    const handleAllowanceConfirm = async ({ data }) => {
        await metaFn(data);
    };
    const handleAllowance = () => {
        openDialog(dialogs_1.GlobalDialogKeys.CONTRACT_ALLOWANCE, contract, {
            initialValues: {
                address,
                amount: "0",
                contractType,
                decimals,
            },
            validationSchema: dialog_1.allowanceValidationSchema,
            message: "dialogs.allowance",
            testId: "AllowanceForm",
            onExternalConfirm: handleAllowanceConfirm,
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleAllowance, icon: icons_material_1.HowToVote, message: "form.buttons.allowance", className: className, dataTestId: "AllowanceButton", disabled: disabled || (0, utils_1.shouldDisableByContractType)(contract) || contractFeatures.includes(types_1.ContractFeatures.SOULBOUND), variant: variant }));
};
exports.ContractAllowanceButton = ContractAllowanceButton;
//# sourceMappingURL=index.js.map